import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ClubMemberService } from '../../../services';

@Component({
  selector: 'app-medical-questions',
  templateUrl: './medical-questions.component.html',
  styleUrls: ['./medical-questions.component.css']
})
export class MedicalQuestionsComponent implements OnChanges {
  @Input() clubProgramID;
  @Input() userID;

  medicalQuestions: any = {};

  constructor(
    private clubMemberService: ClubMemberService,
    private spinner: Ng4LoadingSpinnerService,
  ) { }

  ngOnChanges() {
    if (this.clubProgramID && this.userID) {
      this.clubMemberService.getMedicalQuestions(this.clubProgramID, this.userID).subscribe(res => {
        this.medicalQuestions = res.data;
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/medical-questions/medical-questions.component.ts